export default __webpack_public_path__ + "static/castings-7a77676a1ee7a18f53a100f85021999b.png";